module.exports = __webpack_public_path__ + "img/pagina-exemplo.bad685fd.png";